import { initializeApp, type FirebaseApp } from 'firebase/app'

/**
 * Firebase uygulaması — TEK örnek.
 *
 * Bildirim ve analitik ayrı modüller ama aynı uygulamayı paylaşıyorlar.
 * Her biri kendi initializeApp'ini çağırsaydı Firebase ikinci çağrıda
 * hata veriyor ("Firebase App named '[DEFAULT]' already exists") ve hangi
 * modülün önce yüklendiğine bağlı, açıklaması zor bir kırılganlık
 * doğardı.
 *
 * YAPILANDIRMA GİZLİ DEĞİL. Firebase'in web anahtarları tasarım gereği
 * herkese açık: JavaScript paketinin içinde dağıtılıyorlar ve tarayıcının
 * ağ sekmesinden okunabiliyorlar. Güvenlik buradan değil, Firebase
 * kurallarından ve sunucunun kendi kimlik doğrulamasından geliyor. Ortam
 * değişkenine saklamak, gizli olmayan bir şeyi gizliymiş gibi göstermek
 * olurdu.
 */
const config = {
  apiKey: 'AIzaSyDIU6MRe8pahJi34P-YqlTNPeQba4j7NYM',
  authDomain: 'nakito-52ab8.firebaseapp.com',
  projectId: 'nakito-52ab8',
  storageBucket: 'nakito-52ab8.firebasestorage.app',
  messagingSenderId: '641433021980',
  appId: '1:641433021980:web:521f822a71d50cc23d79d9',
  measurementId: 'G-T2SBK0YM3H',
}

let app: FirebaseApp | undefined

export function firebaseApp(): FirebaseApp {
  return (app ??= initializeApp(config))
}
